import TablaLicenciasVinosLicores from './TablaLicenciasVinosLicores';

const LicenciasVinosLicoresIndex = () => {
  return <TablaLicenciasVinosLicores />;
};

export default LicenciasVinosLicoresIndex;